import React, { FC, memo } from 'react';
import { Checkbox } from '@src/atoms/Checkbox';
import { useLegoElementValue } from '../../hooks';

export const LegoElementCheckbox: FC<Omit<Parameters<typeof Checkbox>[0], 'onChange' | 'value'>> = memo(
  ({ id, ...props }) => {
    const { value, onChange } = useLegoElementValue(id);

    return <Checkbox {...props} value={value} onChange={onChange} id={id} />;
  },
);
